var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSqrenvelope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.3,10.5c-0.2,0.2-0.5,0.2-0.7,0L4.7,7.4v4.8h8.5l0-4.8L9.3,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,0H1C0.4,0,0,0.4,0,1V17c0,0.5,0.4,1,1,1h16c0.5,0,1-0.4,1-1V1C18,0.4,17.5,0,17,0z M14.3,12.2c0,0.6-0.5,1.1-1.1,1.1 H4.7c-0.6,0-1.1-0.5-1.1-1.1V5.8c0-0.6,0.5-1.1,1.1-1.1h8.5c0.6,0,1.1,0.5,1.1,1.1V12.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.2,6.1 13.2,5.8 4.7,5.8 4.7,6.1 9,9.4  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqrenvelope);
export default __webpack_public_path__ + "static/media/sqrenvelope.f36e577cdcb1d0a501b14b9f29cfd937.svg";
export { ForwardRef as ReactComponent };